import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, WIDGET } from "@voltmoney/schema";
import { ACTION } from "./type";
import { ROUTE } from "../../routes";
import { PartnerAccountType } from "../../configs/constants";
import { isPartnerAffiliated } from "../../configs/utils";
export const EmptyEarningMobEmptyStateStack = async (partnerAccountType) => {
    const DS = {
        EmptyEarningMobEmptyStateStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            padding: {
                top: SizeTypeTokens.XXXXL
            },
            widgetItems: [
                { id: 'EmptyEarningMobEmptyStateIcon', type: WIDGET.ICON },
                { id: 'EmptyEarningMobEmptyStateStackSpace0', type: WIDGET.SPACE },
                { id: 'EmptyEarningMobEmptyStateStackT1', type: WIDGET.TEXT },
                { id: 'EmptyEarningMobEmptyStateStackSpace1', type: WIDGET.SPACE },
                { id: 'EmptyEarningMobEmptyStateStack1', type: WIDGET.STACK },
                { id: 'EmptyEarningMobEmptyStateStackSpace2', type: WIDGET.SPACE },
                { id: 'EmptyEarningMobEmptyStateStack2', type: WIDGET.STACK },
            ]
        },
        EmptyEarningMobEmptyStateStack2: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            maxWidth: 386,
            widgetItems: [
                { id: 'EmptyEarningMobEmptyState_ShareUniqueLinkMobStack', type: WIDGET.STACK },
                (partnerAccountType && partnerAccountType === PartnerAccountType.INDIVIDUAL) ? { id: 'EmptyEarningMobEmptyStateStack2Space0', type: WIDGET.SPACE } : {},
            ]
        },
        EmptyEarningMobEmptyState_ShareUniqueLinkMobStack: {
            type: StackType.row,
            flex: 1,
            widgetItems: [
                { id: 'EmptyEarningMobEmptyState_hareUniqueLinkMobBtn', type: WIDGET.BUTTON }
            ]
        },
        EmptyEarningMobEmptyState_RegisterLeadsMobStack: {
            type: StackType.row,
            flex: 1,
            widgetItems: [
                { id: 'EmptyEarningMobEmptyState_RegisterLeadsMobBtn', type: WIDGET.BUTTON }
            ]
        },
        EmptyEarningMobEmptyState_hareUniqueLinkMobBtn: {
            type: ButtonTypeTokens.MediumSoftFilled,
            width: ButtonWidthTypeToken.FULL,
            label: 'Share unique link',
            action: {
                type: ACTION.SHARE_LINK_REF,
                routeId: ROUTE.EARNING,
                payload: {}
            }
        },
        EmptyEarningMobEmptyState_RegisterLeadsMobBtn: {
            type: ButtonTypeTokens.MediumFilled,
            width: ButtonWidthTypeToken.FULL,
            label: 'Register customer',
            action: {
            // routeId: ROUTE.PARTNER_ACTIVE_CUSTOMER,
            // type: ACTION.ON_REGISTER_LEADS,
            // payload: {}
            }
        },
        EmptyEarningMobEmptyStateIcon: {
            name: IconTokens.List,
            size: IconSizeTokens.XXXXXXXXL,
        },
        EmptyEarningMobEmptyStateStack1: {
            type: StackType.row,
            width: StackWidth.CONTENT,
            maxWidth: 386,
            padding: {
                top: SizeTypeTokens.MD,
                bottom: SizeTypeTokens.MD,
                left: SizeTypeTokens.LG,
                right: SizeTypeTokens.LG
            },
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2
            },
            bgColor: ColorTokens.Grey_Milk,
            widgetItems: [
                { id: 'EmptyEarningMobEmptyStateStack1T1', type: WIDGET.TEXT }
            ]
        },
        EmptyEarningMobEmptyStateStack1T1: {
            label: isPartnerAffiliated(partnerAccountType) ?
                `Register or invite your client and earn upfront earnings of Rs 300 per client & 1% trail income` :
                `Register or invite your client and earn upfront earning of ₹200 per client and 0.5% trail income`,
            fontWeight: "400",
            textAlign: 'center',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            lineHeight: 18
        },
        EmptyEarningMobEmptyStateStackT1: {
            label: 'No earnings found',
            fontWeight: "600",
            textAlign: 'center',
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.MD,
            lineHeight: 24
        },
        EmptyEarningMobEmptyStateStackSpace0: {
            size: SizeTypeTokens.MD
        },
        EmptyEarningMobEmptyStateStackSpace1: {
            size: SizeTypeTokens.XL
        },
        EmptyEarningMobEmptyStateStackSpace2: {
            size: SizeTypeTokens.XL
        },
        EmptyEarningMobEmptyStateStack2Space0: {
            size: SizeTypeTokens.XL
        },
    };
    return DS;
};
